import _ from '../../utils/_';
import useAuth from '../../hooks/use-auth/use-auth';
import {emit} from '../../utils/events';
import {useSelector} from 'react-redux';
import {selectUserSettingsData} from '../../../redux/reducers/userSettingsReducer';

import Button from '../button/button';
import BuyNowButton from '../../atomic-design/molecules/Buttons/BuyNow/BuyNowButton';
import ActionButton from '@/molecules/Buttons/Action/ActionButton';
import CtaButton from '@/atoms/Buttons/CTA/CtaButton';
import './product-btn-set.scss';

const ProductBtnSet = ({
  pdpExp,
  product,
  print,
  hasPrints,
  hideDislike = false,
  primaryFn,
  pdp = false,
  onAddToBasket = null,
}: propTypes) => {
  const auth = useAuth();
  const settings = useSelector(selectUserSettingsData);

  const commissionClick = () => {
    if (pdp) {
      emit('CLICK_COMMISSION_ARTIST');
    } else {
      window.location.href = `${product.url}?commission_request=1`;
    }
  };

  const handleMakeOffer = () => {
    if (auth.isAuthenticated()) {
      emit('CLICK_ON_MAKE_OFFER', product);
    } else {
      emit('CLICK_ON_JOIN');
    }
  };

  return (
    <div className="btn-container">
      {/** *** PRIMARY BUTTONS *****/}
      {(print ? print : product).is_in_stock && (
        <BuyNowButton
          currency={settings.currency}
          product={print ? print : product}
          maxWidth="100%"
        />
      )}

      {!(print ? print : product).is_in_stock && hasPrints && !pdp && (
        <Button onClick={primaryFn}>Shop prints</Button>
      )}

      {((!product.is_in_stock && !hasPrints && product.artist_accepts_commissions) ||
        (!product.is_in_stock && pdp && product.artist_accepts_commissions)) && (
        <CtaButton onClick={commissionClick} maxWidth="100%">
          Commission this artist
        </CtaButton>
      )}

      {/** *** SECONDARY BUTTONS *****/}

      {!!product.is_in_stock && !!product.accepts_offers && (
        <ActionButton icon="comment" onClick={handleMakeOffer} maxWidth="100%">
          Make an Offer
        </ActionButton>
      )}
    </div>
  );
};

interface propTypes {
  pdpExp?: Object;
  product: any;
  print?: any;
  hasPrints: boolean;
  hideDislike?: boolean;
  primaryFn?: any;
  pdp?: boolean;
  onAddToBasket?: any;
}

export default ProductBtnSet;
